import { FC } from 'react'
import { Box, Grid } from 'src/components/UI'
import { ESTIMATE_STATUS, FORM_TYPE, STAGE_TYPE } from 'src/helpers'
import ColumnLane from './ColumnLane'
import { ColumnLaneProps } from './ColumnLane/types'

import useStyles from './styles'

const ColumnBoard: FC = () => {
  const styles = useStyles()

  const searchParamArray: ColumnLaneProps[] = [
    {
      stage: STAGE_TYPE.NEW,
      searchParams: {
        onHold: false,
        status: ESTIMATE_STATUS.NEW,
        sortBy: 'dueOn',
        estimateFormType: [
          FORM_TYPE.CLIENT_INSPECTION_REPORT,
          FORM_TYPE.INTERNAL,
          FORM_TYPE.HOMEPLAN_INSPECTION_REQUEST,
        ],
        sortOrder: 'ASC',
      },
      headerBackground: '#E5F7FF',
      laneBackground: '#FAFDFF',
    },
    {
      stage: STAGE_TYPE.OCR_REVIEW,
      searchParams: {
        onHold: false,
        status: ESTIMATE_STATUS.OCR_REVIEW,
        sortBy: 'dueOn',
        sortOrder: 'ASC',
      },
      headerBackground: '#EBECEF',
      laneBackground: '#F9FAFA',
    },
    {
      stage: STAGE_TYPE.API,
      searchParams: {
        onHold: false,
        status: ESTIMATE_STATUS.NEW,
        sortBy: 'dueOn',
        estimateFormType: [FORM_TYPE.PUNCHLIST_API],
        sortOrder: 'ASC',
      },
      headerBackground: '#D6DFFF',
      laneBackground: '#FAFBFF',
    },
    {
      stage: STAGE_TYPE.REPAIR_LIST,
      searchParams: {
        onHold: false,
        status: ESTIMATE_STATUS.NEW,
        sortBy: 'dueOn',
        estimateFormType: [FORM_TYPE.CLIENT_REPAIR_LIST],
        sortOrder: 'ASC',
      },
      headerBackground: '#F6FDE2',
      laneBackground: '#FCFEF5',
    },
    {
      stage: STAGE_TYPE.COMPOSING,
      searchParams: {
        onHold: false,
        status: ESTIMATE_STATUS.COMPOSING,
        sortBy: 'dueOn',
        sortOrder: 'ASC',
      },
      headerBackground: '#D6DFFF',
      laneBackground: '#FAFBFF',
    },
    {
      stage: STAGE_TYPE.REVIEW,
      searchParams: {
        onHold: false,
        status: ESTIMATE_STATUS.IN_REVIEW,
        sortBy: 'dueOn',
        sortOrder: 'ASC',
      },
      headerBackground: '#D9E0F2',
      laneBackground: '#FAFDFF',
    },
    {
      stage: STAGE_TYPE.FINAL_REVIEW,
      searchParams: {
        onHold: false,
        status: ESTIMATE_STATUS.READY_FOR_RELEASE,
        sortBy: 'dueOn',
        sortOrder: 'ASC',
      },
      headerBackground: '#FFE5A3',
      laneBackground: '#FFFBF0',
    },
    {
      stage: STAGE_TYPE.ON_HOLD,
      searchParams: {
        onHold: true,
        sortBy: 'dueOn',
        sortOrder: 'ASC',
      },
      headerBackground: '#E3E0FF',
      laneBackground: '#F1F0FF',
    },
    // {
    //   stage: 'Pending Approvals',
    //   searchParams: {
    //     onHold: false,
    //     status: ESTIMATE_STATUS.PENDING_APPROVALS,
    //     sortBy: 'dueOn',
    //     sortOrder: 'ASC',
    //   },
    //   headerBackground: '#D2F9E9',
    //   laneBackground: '#EDFDF6',
    // },
  ]

  return (
    <Grid container className={styles.container}>
      <Box className={styles.row}>
        {searchParamArray.map((prop, index) => (
          <ColumnLane key={index} {...prop} />
        ))}
      </Box>
    </Grid>
  )
}

export default ColumnBoard
